<template>
  <div class="d-flex justify-content-end w-100 mb-auto">
    <d-button
      type="button"
      class="btn btn-sm py-1 px-3"
      @click="callGenerate"
    >
      Gerar
    </d-button>
    <d-button
      type="button"
      class="btn btn-danger btn-sm ml-2 py-1 px-3"
      @click="callClear"
    >
      Limpar
    </d-button>
  </div>
</template>

<script>
export default {
  name: 'action-buttons',
  props: {
    onGenerate: {
      type: Function,
      required: true,
    },
    onClear: {
      type: Function,
      required: true,
    },
  },
  methods: {
    callGenerate() {
      this.onGenerate();
    },
    callClear() {
      this.onClear();
    },
  },
};
</script>
